<template>
  <div class="gui-flex gui-flex-rows">
    <div v-if="loading" class="pa-5">
      <Loader :loading="true" skin="light"></Loader>
    </div>
    <v-layout row wrap v-else>
      <v-flex xs12 class="pa-4">
        <v-layout row wrap>
          <v-flex xs6 sm6 class="mb-3">
            <p class="grey--text caption mb-1 bold">Vaše pozice:</p>
            <strong>{{kariera.pozice}}</strong>
          </v-flex>
          <v-flex xs6 sm6 class="mb-3">
            <p class="grey--text caption mb-1 bold">Struktura - spolupracovníci:</p>
            <strong>{{spolupracovnici}}</strong>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 sm6 class="mb-3">
            <p class="grey--text caption mb-1 bold">Hodnota kreditu:</p>
            <strong>{{kariera.hodnota_kreditu}} Kč</strong>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 sm6 class="mb-3">
            <p class="grey--text caption mb-1 bold">Vlastní kredity:</p>
            <strong>{{kredity.vlastni_kredity | formatMoney}} kr.</strong>
          </v-flex>
          <v-flex xs6 sm6 class="mb-3">
            <p class="grey--text caption mb-1 bold">Kredity ze struktury:</p>
            <strong>{{kredity.skupinove_kredity | formatMoney}} kr.</strong>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      kariera: {},
      kredity: {},
      spolupracovnici: {},
    }
  },
  mounted: function() {
    window.API.get("osoby/"+this.$props.id+"/pozice").then(function(body) {
      this.kariera = body.kariera;
      this.kredity = body.kredity;
      this.spolupracovnici = body.spolupracovnici;
      this.loading = false;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  },
  props: {
    id: String
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/Pozice.vue